module.exports = __webpack_public_path__ + "img/express-consign-miniapp.de0cc3e.png";